import { render } from "./raceDivideManager.vue?vue&type=template&id=3ebc00ff&scoped=true"
import script from "./raceDivideManager.vue?vue&type=script&lang=js"
export * from "./raceDivideManager.vue?vue&type=script&lang=js"

import "./raceDivideManager.vue?vue&type=style&index=0&id=3ebc00ff&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ebc00ff"]])

export default __exports__